import { Alert, AlertProps } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export type RelatedFormsAlertProps = Omit<AlertProps, 'children'>;

export const RelatedFormsAlert: React.FC<RelatedFormsAlertProps> = ({
  ...props
}) => {
  const { t } = useTranslation(['templates']);

  return (
    <Alert title={t('relatedForms.title')} color="blue" {...props}>
      {t('relatedForms.content')}
    </Alert>
  );
};
